import React, { useState, useMemo } from 'react';
import './MyAvatarSelection.css';

const avatarContext = require.context('../../assets/Avatars', false, /\.(png|jpe?g|svg)$/);
const avatars = Object.keys(avatarContext.keys().reduce((acc, key) => {
  acc[key.replace('./', '')] = avatarContext(key);
  return acc;
}, {}));

const AVATARS_PER_PAGE = 6;

const MyAvatarSelection = ({ currentAvatar, onSelectAvatar }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(avatars.length / AVATARS_PER_PAGE);

  const currentAvatars = useMemo(() => {
    const startIndex = (currentPage - 1) * AVATARS_PER_PAGE;
    return avatars.slice(startIndex, startIndex + AVATARS_PER_PAGE);
  }, [currentPage]);

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisible = 3; // Show only 3 page numbers

    if (totalPages <= maxVisible) {
      // If there are 3 or fewer pages, show all
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Calculate the range of pages to show
      let start = Math.max(currentPage - 1, 1);
      let end = Math.min(start + maxVisible - 1, totalPages);

      // Adjust start if we're at the end of the range
      if (end === totalPages) {
        start = Math.max(end - maxVisible + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers.map((page) => (
      <button
        key={page}
        onClick={() => handlePageClick(page)}
        className={`page-number ${currentPage === page ? 'active' : ''}`}
      >
        {page}
      </button>
    ));
  };

  return (
    <div className="avatar-selection-container">
      <div className="avatar-selection-grid">
        {currentAvatars.map((avatar) => (
          <div key={avatar} className="avatar-option">
            <img
              src={avatarContext(`./${avatar}`)}
              alt={`Avatar ${avatar}`}
              onClick={() => onSelectAvatar(avatar)}
              className={currentAvatar === avatar ? 'selected' : ''}
            />
          </div>
        ))}
      </div>
      <div className="pagination-controls">
        <button onClick={handlePrevious} disabled={currentPage === 1}>
          Previous
        </button>
        {renderPageNumbers()}
        <button onClick={handleNext} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
};

export default MyAvatarSelection;